import CarouselAutomation from "components/carousel-automation"
import automationService from 'data/automation'
import keyService, * as chord from "data/key"
import propertyService from 'data/property'
import _ from 'lodash'
import React, { FC, useEffect, useState } from 'react'
import { CarouselContent_s, CarouselTabs_s } from './carousel-styles'


interface Props {
  controls: object,
  defaults?: object,
  field: string,
  data: object,
  namedItems?: object,
  outsideTable?: boolean,
  persist: Function
  table?: string
}

const CarouselContent: FC<Props> = (props) => {
  const [propertyId, setPropertyId]  = useState(propertyService.getStoredPropertyId())
  let   initialCarouselState         = ''
  if (_.get(props.data, props.field)){
    let state = _.get(props.data, props.field)?.state
    initialCarouselState = state ? state : _.get(props.data, props.field)
  } else if (props.data['inputtype']){
    initialCarouselState = props.data['inputtype']
  }
  const tabStates                    = Object.keys(props.controls);
  const [activeTab, updateActiveTab] = useState<number>(tabStates.indexOf(initialCarouselState) !== -1 ? tabStates.indexOf(initialCarouselState) : 0);
  const Control                      = props.controls[tabStates[activeTab]].control;

  useEffect(() => {
    const overrideKeyHandlers = e => {
      // disable keyboard scroll control and native tabbing
      if(_.includes(["Shift", "Tab"], e.key)) {
        e.preventDefault()
        return false
      }
      // disable browser zoom on hotkey add/delete
      if(e.ctrlKey && _.includes(["_", "=", "+", "-", "Add", "Subtract"], e.key)) {
        e.preventDefault()
        return false
      }
      return true
    }

    const propertySubscription = propertyService.stream().subscribe((data) => {
      switch (data.state) {
        case 'ok':
          if (data.current !== propertyId) setPropertyId(data.current)
          break
      }
    });

    automationService.broadcast("CAROUSEL_STATE_CHANGE", {})

    const keySubscription = keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_SHIFT_LEFT && k.down === true:
          if(activeTab - 1 < 0) updateActiveTab(tabStates.length - 1)
          else updateActiveTab(activeTab - 1)
          break
        case k.chord === chord.CTRL_SHIFT_RIGHT && k.down === true:
          if(activeTab + 1 === tabStates.length) updateActiveTab(0)
          else updateActiveTab(activeTab + 1)
          break
      }
    });

    document.addEventListener("keydown", overrideKeyHandlers)

    return function cleanup() {
      propertySubscription.unsubscribe()
      keySubscription.unsubscribe()
      document.removeEventListener("keydown", overrideKeyHandlers)
    }
  }, [activeTab])

  useEffect(() => {
    updateActiveTab(tabStates.indexOf(initialCarouselState) !== -1 ? tabStates.indexOf(initialCarouselState) : 0)
  }, [propertyId])

  const isRecoveryCarousel = props.field === 'recoverydetail' && !window.location.href.includes("named-recoveries")

  return (
    <CarouselContent_s id="carousel-content-container">
      { tabStates.length > 1 &&
        <CarouselTabs_s>
          { tabStates.map((state, i) =>
            <li
              data-active={activeTab === i}
              onClick={e => updateActiveTab(i)}
              data-chosen={!isRecoveryCarousel && state === initialCarouselState}
            >
              { props.controls[state].name }
              { isRecoveryCarousel && props.data[props.field]?.[state]?.length > 0 && ` (${props.data[props.field][state].length})` }
            </li>)
          }
        </CarouselTabs_s>
      }
      {/* <div style={!props.outsideTable ? {maxHeight: 'calc(96vh - 200px)', overflowY: 'scroll', paddingRight: '18px'} : {}}> */}
        <Control field={props.field} rowData={props.data} persist={props.persist} namedItems={props.namedItems} defaults={props.defaults} table={props.table}/>
      {/* </div> */}
      <CarouselAutomation activeTab={activeTab} outsideTable={props.outsideTable} automationContainerId="carousel-content-container"/>
    </CarouselContent_s>
  )

}

export default CarouselContent
